<template>
  <div>
    <h1>Add Comp</h1>
    <div class="columns">
      <div class="column">
        <div class="field is-clearfix">
          <label class="label">First Name:</label>
          <div class="control">
            <input
              class="input is-primary"
              type="text"
              required
              placeholder="First Name"
              v-model="firstName"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field is-clearfix">
          <label class="label">Last Name:</label>
          <div class="control">
            <input
              class="input is-primary"
              type="text"
              required
              placeholder="Last Name"
              v-model="lastName"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="field is-clearfix">
      <label class="label">Email:</label>
      <div class="control has-icons-left">
        <input
          class="input is-primary"
          type="email"
          required
          placeholder="Email"
          v-model="email"
        />
        <span class="icon is-small is-left">
          <i class="fas fa-envelope"></i>
        </span>
      </div>
      <p class="help is-danger" v-if="!emailValid">
        Please enter a valid email address.
      </p>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field is-clearfix">
          <label class="label">Quantity:</label>
          <input
            class="input"
            type="number"
            required
            min="1"
            v-model.number="quantity"
          />
        </div>
      </div>
      <div class="column" v-if="availableTiers.length > 1">
        <div class="field is-clearfix">
          <label class="label">Price Tier:</label>
          <div class="control">
            <div class="select is-fullwidth">
              <select v-model="selectedTierId" required>
                <option value="">Select a tier</option>
                <option
                  v-for="tier in availableTiers"
                  :key="tier.id"
                  :value="tier.id"
                >
                  {{ tier.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="field is-clearfix">
      <label class="label">Note:</label>
      <div class="control">
        <input
          class="input is-primary"
          type="text"
          required
          placeholder="Note"
          v-model="note"
        />
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <button class="button is-fullwidth" @click="cancel">Cancel</button>
      </div>
      <div class="column">
        <button
          class="button is-fullwidth is-primary"
          @click="add"
          :disabled="isAddDisabled"
        >
          Add Comp
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import { mapGetters } from "vuex";

export default {
  name: "addcomp",
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      quantity: 1,
      note: "",
      emailValid: true,
      selectedTierId: ""
    };
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      event: "event",
      dateSummary: "dateSummary",
      priceTiers: "priceTiers",
      user: "user"
    }),
    availableTiers() {
      // Filter tiers based on date-specific availability
      const dateId = this.dateSummary?.dateId;
      return this.priceTiers.filter(tier => {
        if (!tier.selectDates) return true;
        return tier.selectedDates && tier.selectedDates.indexOf(dateId) > -1;
      });
    },
    selectedTierName() {
      if (!this.selectedTierId) return "";
      const tier = this.availableTiers.find(t => t.id == this.selectedTierId);
      return tier ? tier.name : "";
    },
    isAddDisabled() {
      // Disable if quantity is less than 1 or if multiple price tiers available but none is selected
      return (
        this.quantity < 1 ||
        (this.availableTiers.length > 1 && !this.selectedTierId)
      );
    }
  },
  mounted() {
    // Auto-select the tier if there's only one available for this date
    if (this.availableTiers.length === 1) {
      this.selectedTierId = this.availableTiers[0].id;
    }
  },
  methods: {
    async add() {
      var db = firebase.firestore();

      // Build the comp record
      const compRecord = {
        checkedin: 0,
        comp: true,
        discountCode: this.note,
        email: this.email,
        firstName: this.firstName,
        lastName: this.lastName,
        price: 0,
        quantity: this.quantity,
        status: "paid",
        total: 0,
        createdBy: this.user.uid,
        createdByName: this.user.displayName || this.user.email,
        createdAt: firebase.firestore.FieldValue.serverTimestamp()
      };

      // Add tier information if a tier is selected
      if (this.selectedTierId && this.selectedTierName) {
        compRecord.tierId = this.selectedTierId;
        compRecord.tierName = `COMP: ${this.selectedTierName}`;
      } else {
        compRecord.tierName = "Comp";
      }

      await db
        .collection("events")
        .doc(this.event.id)
        .collection("userData")
        .doc("audienceReport")
        .collection("dates")
        .doc(this.dateSummary.dateId)
        .collection("audience")
        .add(compRecord)
        .catch(function(error) {
          console.error("Error adding document: ", error);
        });
      this.$emit("compAdded");
    },
    cancel() {
      this.firstName = this.lastname = this.note = "";
      this.quantity = 1;
      this.selectedTierId = "";
      this.$emit("canceled");
    }
  }
};
</script>

<style></style>
